import { FC, useCallback, useMemo } from 'react';
import {
  AlgorithmTestCalculationType,
  ButtonGroupNav,
  ButtonGroupNavItem,
  useQueryParams,
} from '@atlas-frontend/sdk';
import { TestCalculationSegment } from '../types';
import { expand } from 'uri-template-lite';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './TestCalculationReportButtonNav.translations.json';

const { addTranslations, t } = i18nNsFactory(
  'output-data-test-calculation-button-nav',
);
addTranslations(translations);

export const TestCalculationReportButtonNav: FC<{
  counts: { [key in TestCalculationSegment]: number };
  params: AlgorithmTestCalculationType;
}> = (props) => {
  const { counts, params } = props;

  const expandUrlTemplate = useCallback(
    (segment: TestCalculationSegment) =>
      expand(
        `/data/output-data/test-calculation{?segment,algorithmIds,sourceDataVersionId,valueDate}`,
        {
          segment,
          ...params,
        },
      ),
    [params],
  );

  const items: ButtonGroupNavItem<TestCalculationSegment>[] = useMemo(
    () => [
      {
        key: 'outputData',
        label:
          t('segment.outputData') +
          (counts.outputData ? ` (${counts.outputData})` : ''),
        to: expandUrlTemplate('outputData'),
      },
      {
        key: 'calculationErrors',
        label:
          t('segment.calculationErrors') +
          (counts.calculationErrors ? ` (${counts.calculationErrors})` : ''),
        to: expandUrlTemplate('calculationErrors'),
      },
      {
        key: 'missingSourceData',
        label:
          t('segment.missingSourceData') +
          (counts.missingSourceData ? ` (${counts.missingSourceData})` : ''),
        to: expandUrlTemplate('missingSourceData'),
      },
    ],
    [expandUrlTemplate, counts],
  );

  const [{ segment }] = useQueryParams();

  return <ButtonGroupNav items={items} currentKey={segment} />;
};
